import { format } from 'date-fns';

export const getDate = (timestamp: string): string => {
  const date = new Date(parseInt(timestamp) * 1000);
  return format(date, 'yyyy-MM-dd HH:mm:ss');
};

export const getUTCDate = (timestamp: string): string => {
  let timestampInt = parseInt(timestamp);
  const offset = new Date().getTimezoneOffset();
  timestampInt = timestampInt + offset * 60;
  const date = new Date(timestampInt * 1000);
  return format(date, 'yyyy-MM-dd HH:mm:ss');
};

export const getSystemTZ = () => {
  const offset = new Date().getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offset) / 60);
  const offsetMinutes = Math.abs(offset) % 60;
  const offsetSign = offset <= 0 ? '+' : '-';
  const formattedOffset =
    offsetSign +
    String(offsetHours).padStart(2, '0') +
    ':' +
    String(offsetMinutes).padStart(2, '0');
  return formattedOffset;
};
